import { render, staticRenderFns } from "./MagicLinkLogin.vue?vue&type=template&id=61831f49&scoped=true&"
import script from "./MagicLinkLogin.vue?vue&type=script&lang=js&"
export * from "./MagicLinkLogin.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkLogin.vue?vue&type=style&index=0&id=61831f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61831f49",
  null
  
)

export default component.exports